import { User } from 'src/renderless/useAuth';

const isAllowedAccess = (user: User) =>
  user.type === 'logged' && user.value.wizardless_check_access;

export default isAllowedAccess;
